import { requests } from './baseServices'

export const VatServices = {    
    //getAll: (criteria) => requests.get('api/vat', criteria),
    getAllWithOptions: (criteria) => requests.post('api/vat/filtered', criteria),
    getById: (id) => requests.get(`api/vat/${id}`),
    update: (id, template) => requests.put(`api/vat/${id}`, template),
    create: (template) => requests.post(`api/vat`, template),
    duplicate: (id) => requests.post(`api/vat/duplicate/${id}`),
    delete: (id) => requests.delete(`api/vat/${id}`),
};